// This file was automatically generated from tourguide.homeSuggestChart.html.
// Please don't edit this file by hand.

goog.provide('el8.template.tourguide.homeSuggestChart');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.tourguide.homeSuggestChart.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="suggestInfoBoxContainer"><div class="suggestInfoBoxCloseTrigger close-trigger"></div><p class="suggestInfoBoxText">When you\'re ready to move on, click the sample patient\'s name above to explore the Patient Chart.</p></div><div class="tourGuideInfoBoxPointerTop"></div>');
  if (!opt_sb) return output.toString();
};
